export default __webpack_public_path__ + "images/f22a94c8941747b260cecbcc537ac5ff-man1.jpg";